"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHairDryerFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M22 3.804a1 1 0 00-1.53-.848l-1.954 1.222c-.448-.116-.9-.235-1.352-.355C13.768 2.927 10.254 2 7 2a5 5 0 00-.918 9.916l1.97 8.534a2 2 0 003.897-.9l-1.8-7.797c2.313-.335 4.692-.963 7.015-1.576.453-.12.904-.239 1.351-.355l1.955 1.222a1 1 0 001.53-.848V3.804zM7 9a2 2 0 100-4 2 2 0 000 4z' }))); };
exports.default = SvgHairDryerFilled;
//# sourceMappingURL=HairDryerFilled.js.map